import React, { useContext } from "react";

import { ManageCompleteUserProfileContext } from "./";

const BankInfo = () => {
  const [userInfoState, userInfoContextDispatch] = useContext(
    ManageCompleteUserProfileContext
  );
  const userInfo = userInfoState.userInfo;

  const handleInputChange = (e) => {
    userInfoContextDispatch({
      type: "ON_CHANGE_USER_INFO",
      payload: { [e.target.name]: e.target.value },
    });

    userInfoContextDispatch({
      type: "CLEAR_ERROR_MESSAGES",
      payload: { [e.target.name]: [] },
    });
  };

  // Clean error messages when click on the input
  const hideErrorMessage = (e) => {
    userInfoContextDispatch({
      type: "CLEAR_ERROR_MESSAGES",
      payload: { [e.target.getAttribute("name")]: [] },
    });
  };

  return (
    <div className="row">
      <div className="col-lg-6">
        <div className="input-box-area" single-labe="true">
          <label>Bank Account Holder Name :</label>
          <input
            type="text"
            placeholder="Bank Account Holder Name"
            name="bank_account_holder_name"
            onChange={handleInputChange}
            value={userInfo.user_obj.bank_account_holder_name}
            onMouseMove={hideErrorMessage}
          />
          <div className="error" show-tittle="true">
            {userInfoState.userInfoError?.bank_account_holder_name.length >
            0 ? (
              <div>
                {" "}
                <i className="fa-solid fa-circle-exclamation"></i>{" "}
              </div>
            ) : (
              ""
            )}
            {userInfoState.userInfoError?.bank_account_holder_name?.map(
              (error, index) => (
                <div>
                  <p className="auth-error" key={index}>
                    {error}
                  </p>
                </div>
              )
            )}
          </div>
        </div>

        <div className="input-box-area" single-labe="true">
          <label>Bank Account Number :</label>
          <input
            type="text"
            placeholder="Bank Account Number"
            name="bank_account_number"
            value={userInfo.user_obj.bank_account_number}
            onChange={handleInputChange}
            onMouseMove={hideErrorMessage}
          />
          <div className="error" show-tittle="true">
            {userInfoState.userInfoError?.bank_account_number.length > 0 ? (
              <div>
                {" "}
                <i className="fa-solid fa-circle-exclamation"></i>{" "}
              </div>
            ) : (
              ""
            )}
            {userInfoState.userInfoError?.bank_account_number?.map(
              (error, index) => (
                <div>
                  <p className="auth-error" key={index}>
                    {error}
                  </p>
                </div>
              )
            )}
          </div>
        </div>

        <div className="input-box-area" single-labe="true">
          <label>Bank Account Country :</label>
          <input
            type="text"
            placeholder="Bank Account Country"
            name="bank_account_country"
            value={userInfo.user_obj.bank_account_country}
            onChange={handleInputChange}
            onMouseMove={hideErrorMessage}
          />
          <div className="error" show-tittle="true">
            {userInfoState.userInfoError?.bank_account_country.length > 0 ? (
              <div>
                {" "}
                <i className="fa-solid fa-circle-exclamation"></i>{" "}
              </div>
            ) : (
              ""
            )}
            {userInfoState.userInfoError?.bank_account_country?.map(
              (error, index) => (
                <div>
                  <p className="auth-error" key={index}>
                    {error}
                  </p>
                </div>
              )
            )}
          </div>
        </div>
      </div>

      <div className="col-lg-6">
        <div className="input-box-area" single-labe="true">
          <label>Bank Name :</label>
          <input
            type="text"
            placeholder="Bank Name"
            value={userInfo.user_obj.bank_name}
            name="bank_name"
            onChange={handleInputChange}
            onMouseMove={hideErrorMessage}
          />
          <div className="error" show-tittle="true">
            {userInfoState.userInfoError?.bank_name.length > 0 ? (
              <div>
                {" "}
                <i className="fa-solid fa-circle-exclamation"></i>{" "}
              </div>
            ) : (
              ""
            )}
            {userInfoState.userInfoError?.bank_name?.map((error, index) => (
              <div>
                <p className="auth-error" key={index}>
                  {error}
                </p>
              </div>
            ))}
          </div>
        </div>

        <div className="input-box-area" single-labe="true">
          <label> Bank Branch Name</label>
          <input
            type="text"
            placeholder="Bank Branch Name"
            name="bank_account_branch_name"
            value={userInfo.user_obj.bank_account_branch_name}
            onChange={handleInputChange}
            onMouseMove={hideErrorMessage}
          />
          <div className="error" show-tittle="true">
            {userInfoState.userInfoError?.bank_account_branch_name.length >
            0 ? (
              <div>
                {" "}
                <i className="fa-solid fa-circle-exclamation"></i>{" "}
              </div>
            ) : (
              ""
            )}
            {userInfoState.userInfoError?.bank_account_branch_name?.map(
              (error, index) => (
                <div>
                  <p className="auth-error" key={index}>
                    {error}
                  </p>
                </div>
              )
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BankInfo;
